import React, { Fragment, useEffect, useState, useRef } from "react";
import { getEventosCalendarioParis } from "services/getEventosCalendario";
import { getFechasParis } from "../../../services/getFechasCalendario.js";
import Card from "../card/card.js";
import Loading from "components/loading/loading";
import SinResultados from "components/calendarios/calendarioGangwon/sinResultados/sinResultados";
import FiltroDeporte from "../../envivo/filtroDeporte/filtroDeporte.js";
import { getParisSystemDayParis } from "functions/functions.js";
import "./listadoGeneralDia.sass";
import { getCompetenciasParis } from "services/getCompetenciasCalendario.js";


export default function ListadoGeneralDia({ seccion, targetB, showFilter, fechaProp }) {
    const [dataEventos, setDataEventos] = useState([]);
    const [error, setError] = useState(false);
    const [showLoading, setShowLoading] = useState(true);
    const [dataFechas, setDataFechas] = useState(false);
    const [fechaParaFiltrar, setFechaParaFiltrar] = useState();
    const [dataCompetencias, setDataCompetencias] = useState(false);
    const [valorFiltroCompetencias, setValorFiltroCompetencias] = useState(false);

    useEffect(() => {
        getFechasParis()
            .then((data) => {
                setDataFechas(data);
            })
            .catch((error) => {
                console.error("Error al obtener las fechas:", error);
            });
    }, []);

    // obtener data para select deportes
    useEffect(() => {
        getCompetenciasParis()
            .then((data) => {
                setDataCompetencias(data);
            })
            .catch((error) => {
                console.error("Error al obtener las disciplinas:", error);
            });
    }, []);


    // verificacion para obtener la fecha que debe estar por defecto en el select de fecha
    useEffect(() => {
        if(fechaProp && dataFechas){
            let fechaActual = fechaProp;

            const firstDate = dataFechas[0]?.value;
            const lastDate = dataFechas[dataFechas.length - 1]?.value;

            // si la fecha actual es diferente a la fecha inicial - ASIGNA DIA 0
            if (fechaProp <= firstDate) {
                setFechaParaFiltrar(firstDate);
            }
            // si la fecha actual es MAYOR o IGUAL a la fecha fin - ASIGNA ULTIMO DIA
            else if (fechaActual >= lastDate) {
                setFechaParaFiltrar(lastDate);
            }
            // si la fecha actual es IGUAL a alguna de las fechas - ASIGNA LA FECHA QUE COINCIDE
            else if (dataFechas.some((item) => item.value === fechaActual)) {
                // Asigna el valor de fechaActual a setNuevo
                setFechaParaFiltrar(fechaActual);
            }
            // si no coincide con ninguna opción, asigna la fecha de inicio por defecto
            else {
                setFechaParaFiltrar(firstDate);
            }
        }
        else if (dataFechas && !fechaProp) {
            let fechaActual = getParisSystemDayParis();

            const firstDate = dataFechas[0]?.value;
            const lastDate = dataFechas[dataFechas.length - 1]?.value;

            // si la fecha actual es diferente a la fecha inicial - ASIGNA DIA 0
            if (fechaActual <= firstDate) {
                setFechaParaFiltrar(firstDate);
            }
            // si la fecha actual es MAYOR o IGUAL a la fecha fin - ASIGNA ULTIMO DIA
            else if (fechaActual >= lastDate) {
                setFechaParaFiltrar(lastDate);
            }
            // si la fecha actual es IGUAL a alguna de las fechas - ASIGNA LA FECHA QUE COINCIDE
            else if (dataFechas.some((item) => item.value === fechaActual)) {
                // Asigna el valor de fechaActual a setNuevo
                setFechaParaFiltrar(fechaActual);
            }
            // si no coincide con ninguna opción, asigna la fecha de inicio por defecto
            else {
                setFechaParaFiltrar(firstDate);
            }
        }
    }, [fechaProp, dataFechas]);

    // peticion al servicio para obtener los eventos del calendario
    useEffect(() => {
        if (seccion && fechaParaFiltrar) {
            getEventosCalendarioParis(fechaParaFiltrar, seccion)
                .then((eventos) => {
                    let dia = fechaParaFiltrar.replace(/-/g, "");
                    let systemTime= new Date();

                    if (eventos && eventos.data && eventos.statusCode === 200) {
                        let transmissions = eventos.data.elems[dia].sort(function (a, b) {
                            return new Date(a.session_start_time_utc) - new Date(b.session_start_time_utc) || new Date(a.session_end_time_utc) - new Date(b.session_end_time_utc)
                        })

                        // Agregar el campo isLive a cada evento
                        transmissions = transmissions.map(evento => {
                            const isLive = systemTime >= new Date(evento.session_start_time_utc) && systemTime <=  new Date(evento.session_end_time_utc);
                            return { ...evento, envivo: isLive };
                        });
                        setDataEventos(transmissions);

                    } else if (eventos && eventos.statusCode === 404 && eventos.statusCode !== undefined) {
                        setError(true);
                        setDataEventos([]);
                    }
                })
                .finally(() => {
                    setShowLoading(false);
                    setError(false);
                });
        }
    }, [seccion, fechaParaFiltrar])


    //________________ FUNCIONAMIENTO DE FILTRADO _________________
    // funcionamiento del select filtro competencias (deportes)
    const seleccionarFiltroCompetencias = (seleccion) => {
        let competencia = String(seleccion.target.value).trim();

        if (competencia.length === 0) {
            setValorFiltroCompetencias(false);
        } else {
            setValorFiltroCompetencias(competencia);
        }
    };

    // Función de filtro por eventos
    const filtrarEventos = (eventos) => {
        return eventos && eventos.filter((evento) => {
            return (!valorFiltroCompetencias || String(evento.discipline_id).includes(valorFiltroCompetencias));
        });
    };
    //________________ FIN FUNCIONAMIENTO DE FILTRADO _________________




    //------- INICIAR EJECUCION DE REZISE DEL COMPONENTE -------
    const envivoRef = useRef(null);

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const newHeight = entry.contentRect.height;

                window.requestAnimationFrame(() => {
                    const message = {
                        sentinel: "amp",
                        type: "embed-size",
                        height: newHeight,
                    };
                    window.parent.postMessage(message, "*");
                });
            });
        });

        if (envivoRef.current) {
            resizeObserver.observe(envivoRef.current);
        }

        // Limpia el ResizeObserver al desmontar el componente
        return () => {
            resizeObserver.disconnect();
        };
    }, [envivoRef]);
    //------- TERMINA EJECUCION DE REZISE DEL COMPONENTE -------

    return (
        <div ref={envivoRef}>
            {/* seccion loading */}
            {showLoading && (<Loading />)}

            <>
                {!showLoading && String(showFilter) === "true" &&  <FiltroDeporte
                    seleccionarFiltroCompetencias={seleccionarFiltroCompetencias}
                    dataCompetencias={dataCompetencias}
                />
                }

                {/* seccion sin resultados  */}
                {!showLoading && !error && dataEventos && (dataEventos.length === 0 || filtrarEventos(dataEventos).length === 0) && <SinResultados componenteActual={seccion} />}

                {/* seccion con resultados de busqueda del dia */}
                {!showLoading && dataEventos && dataEventos.length !== 0 && <div className="envivo-component-listado-general">

                    <>
                        <div className="container-general-envivo-listado-general">
                            {dataEventos && dataEventos.length !== 0 && filtrarEventos(dataEventos).map((item) =>
                                <Fragment key={item._id}>
                                    <Card imagen={item.image} disciplina={item.discipline} disciplina_id={item.discipline_id} titulo={String(item.session_title).length === 0 ? item.session_title_editorial : item.session_title} horaInicio={item.session_start_time_utc} horaFin={item.session_end_time_utc} enlace={item.url} tipo="icono"  targetB={targetB}  estaEnvivo={item?.is_live}/>
                                </Fragment>
                            )}
                        </div>
                    </>
                </div>
                }
            </>
        </div>
    )
}